"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Credit = void 0;

var _react = _interopRequireDefault(require("react"));

var _baseui = require("baseui");

var _avatar = require("baseui/avatar");

var _typography = require("baseui/typography");

var _propTypes = require("prop-types");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var isEmpty = function isEmpty(entity) {
  return !entity || entity === '';
};

var Root = (0, _baseui.styled)('div', function (_ref) {
  var $theme = _ref.$theme;
  return {
    paddingTop: $theme.sizing.scale200,
    paddingBottom: $theme.sizing.scale200,
    paddingLeft: 0,
    paddingRight: 0,
    display: 'flex'
  };
});
var AvatarContainer = (0, _baseui.styled)('div', {
  flexGrow: 0,
  flexShrink: 0,
  flexBasis: '50px'
});
var InfoContainer = (0, _baseui.styled)('div', function (_ref2) {
  var $theme = _ref2.$theme;
  return {
    flexGrow: 1,
    flexShrink: 0,
    flexBasis: '200px',
    marginLeft: $theme.sizing.scale600
  };
});

var Credit = function Credit(_ref3) {
  var id = _ref3.id,
      description = _ref3.description,
      imageUrl = _ref3.imageUrl,
      name = _ref3.name,
      rest = _objectWithoutProperties(_ref3, ["id", "description", "imageUrl", "name"]);

  return _react["default"].createElement(Root, rest, _react["default"].createElement(AvatarContainer, null, _react["default"].createElement(_avatar.Avatar
  /** Key required to handle bug on paginated items */
  , {
    key: id,
    name: name,
    size: "scale1200",
    src: isEmpty(imageUrl) ? null : imageUrl
  })), _react["default"].createElement(InfoContainer, null, _react["default"].createElement(_typography.Paragraph1, {
    as: "div",
    color: "white"
  }, name), _react["default"].createElement(_typography.Label3, {
    color: "mono600"
  }, description)));
};

exports.Credit = Credit;
Credit.propTypes = {
  id: _propTypes.string.isRequired,
  description: _propTypes.string.isRequired,
  imageUrl: _propTypes.string,
  name: _propTypes.string.isRequired
};
Credit.defaultProps = {
  imageUrl: undefined
};